module.exports = __webpack_public_path__ + "img/nav-design-classic@2x.c1e5836.webp";